<h2 (click)="bottomRef().close()">Wähle ein Event</h2>
<div class="list">
  @for (event of events(); track event; let index = $index) {
    <div class="list-item" (click)="close(index)">
      <span class="title">{{ event.title }}</span>
      <span class="date">{{ event.day | date: 'd. MMM yy' : '+0000' }}</span>
    </div>
  }
</div>
